import { useLocale } from 'next-intl'

import {
  getSportTypes,
  type PublicSportType,
  type SportTypesScope
} from '@/features/sport-types/api/sportTypesApi'
import { createQueryHook } from '@/shared/api'

export const enum SportTypesQueryKeys {
  SPORT_TYPES = 'sport_types'
}

const SPORT_TYPES_STALE_TIME = 5 * 60 * 1000

const useSportTypesFactory = createQueryHook<
  { scope?: SportTypesScope; locale: string },
  PublicSportType[]
>({
  getQueryKey: ({ scope, locale }) => [
    SportTypesQueryKeys.SPORT_TYPES,
    scope ?? 'all',
    locale
  ],
  queryFn: ({ scope }) => getSportTypes(scope),
  getOptions: () => ({ staleTime: SPORT_TYPES_STALE_TIME, retry: false })
})

export function useSportTypes(scope?: SportTypesScope) {
  const locale = useLocale()
  return useSportTypesFactory({ scope, locale })
}
